// extracted by mini-css-extract-plugin
export default {"rating":"kz-z","numberOfStars":"lz-z","count":"mz-z","barGraphSpacing":"nz-z","barGraph":"oz-z"};